import React from "react";
import covenantDesignImg from "../../Assets/Images/covenantDesignImg.png";
import { useNavigate } from "react-router-dom";

const features = [
  "Smart Home Design",
  "Beautiful Scene Around",
  "Exceptional Lifestyle",
  "Complete 24/7 Security",
];

const CovenantsDesign = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-50 py-10 px-4 sm:px-6 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">

        {/* Left Side - Image with Badge */}
        <div className="order-2 lg:order-1 flex justify-center relative">
          <img
            src={covenantDesignImg}
            alt="Covenant Design"
            className="max-w-full sm:max-w-[90%] md:max-w-[80%] xl:max-w-[90%] h-auto object-contain rounded-lg"
          />

          <div
            className="
      bg-[#FF5A3C] absolute top-2 right-2 sm:top-4 sm:right-4 text-white
      h-20 w-20 sm:h-28 sm:w-28 md:h-32 md:w-32 xl:h-44 xl:w-44
      p-2 sm:p-3 md:p-4 xl:p-6
      rounded-lg shadow-lg
      flex flex-col justify-center items-start
    "
          >
            <div className="text-base sm:text-lg md:text-2xl xl:text-4xl font-bold">
              10+
            </div>
            <div className="text-[7px] sm:text-[9px] md:text-xs xl:text-sm leading-tight">
              Years of<br />
              Experience of<br />
              Excellence
            </div>
          </div>
        </div>
        {/* Right Side Content */}
        <div className="order-1 lg:order-2 space-y-5">
          {/* Header Section */}
          <div className="border-l-2 border-[#FF5A3C] pl-3">
            <span className="text-[#FF5A3C] text-xs sm:text-sm md:text-base font-medium">
              About Us
            </span>
          </div>

          {/* Title */}
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl tracking-wider leading-relaxed font-semibold">
            <span>
              <span className="text-[#FF5A3C] underline">Covenants</span>{" "}
              <span className="text-gray-900">Welcomes You to Its World of Excellence!</span>
            </span>
          </h1>

          {/* Description */}
          <p className="text-gray-600 text-sm sm:text-base md:text-md leading-relaxed text-justify">
            At Covenants, We Are Committed To Turning Dreams Into Reality By
            Providing Exceptional Real Estate Solutions. With A Strong
            Foundation Of Trust, Expertise, And Innovation, We Help
            Individuals And Businesses Find The Perfect Properties That Align
            With Their Goals.
          </p>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center gap-3">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <div className="w-2 h-2 sm:w-2 sm:h-2 bg-primaryOrange rounded-full animate-ping"></div>
                </div>
                <span className="text-gray-700 text-xs sm:text-sm font-medium">
                  {feature}
                </span>
              </div>
            ))}
          </div>

          {/* Quote Box */}
          <div className="bg-gray-100 border-l-4 border-primaryOrange p-3 sm:p-4 rounded-r-lg">
            <p className="text-gray-800 font-medium text-xs sm:text-sm md:text-base leading-snug">
              We are not just construct Buildings, we build
              <br className="hidden sm:block" />
              Trust, we build dreams!!
            </p>
          </div>

          {/* CTA Button */}
          <div className="pt-3 sm:pt-4">
            <button onClick={() => navigate("/projects")} className="bg-primaryOrange hover:bg-orange-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors duration-200 shadow-lg text-xs sm:text-sm md:text-base">
              Explore Now
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default CovenantsDesign;